// extracted by mini-css-extract-plugin
export default {"title":"vOwSXqSzugG7O41Ajyk3","contentBox":"uVzeexuuCdzFKEk_PH9N","cellPhoneInput":"alzNhevZQz3g5yN04EQs"};